import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 15.6175,17.0321 C 14.0778,18.2636 12.1249,19 10,19 5.02944,19 1,14.9706 1,10 1,5.02944 5.02944,1 10,1 c 4.9706,0 9,4.02944 9,9 0,2.1249 -0.7364,4.0778 -1.9679,5.6175 L 22.71,21.29 c 0.3905,0.3905 0.3905,1.0295 0,1.42 -0.3905,0.3905 -1.0295,0.3905 -1.42,0 z M 10,3 c -3.86599,0 -7,3.13401 -7,7 0,3.866 3.13401,7 7,7 3.866,0 7,-3.134 7,-7 0,-3.86599 -3.134,-7 -7,-7 z"
  }));
});
var NavigationSearch = AbstractIcon.withComponent(Icon);
NavigationSearch.displayName = 'NavigationSearch';
export default NavigationSearch;